<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-3 pr-1 mb-2">
                    <month-picker-input v-model="date"></month-picker-input>
                </div>
                <div class="col-3 pl-1 pr-1 mb-2">
                    <input v-model="account_no" placeholder="একাউন্ট নম্বর" class="form-control formInput" type="text">
                </div>
                <div class="col-3 pl-1 pr-1 mb-2">
                    <select v-model="ward"  name="word_no" class="form-control formInput" >
                        <option value="">ওয়ার্ড সিলেক্ট করুন</option>
                        <option v-for="(ward,key) in wards" :key="key" :value="ward.id">{{ ward.ward_name_bng}}{{ ward.name}}</option>
                    </select>
                </div>
                <div class="col-3 pl-1 mb-2">
                    <select @change="getSelectService()" v-model="select_dia"  class="form-control formInput">
                        <option value="">লাইনের ব্যাস</option>
                        <option value="0.5">0.5 ইঞ্চি</option>
                        <option value="0.75">0.75 ইঞ্চি</option>
                        <option value="1.00">1 ইঞ্চি</option>
                        <option value="1.5">1.5 ইঞ্চি</option>
                        <option value="1.75">1.75 ইঞ্চি</option>
                        <option value="1">2 ইঞ্চি</option>
                    </select>
                </div>
                <div class="col-3 pr-1 mb-2">
                    <select v-model="service_id" name="Diameter" class="form-control formInput">
                        <option value="">লাইনের ধরন</option>
                        <option :value="diameter.id" v-for="(diameter,key) in service_list" :key="key">{{diameter.name}}&nbsp;{{diameter.diameter}} ইঞ্চি</option>
                    </select>
                </div>

                <div class="col-3 pl-1 pr-1 mb-2">
                    <select v-model="report_type" v-validate="'required'" name="report_type" class="form-control formInput" >
                        <option value="">রিপোর্ট টাইপ</option>
                        <option value="demand">ডিমান্ড</option>
                        <option value="collections">আদায়</option>
                        <option value="demand-collections">ডিমান্ড ও আদায়</option>
                    </select>
                    <p v-show="errors.has('report_type')" style="color:red">* Required</p>
                </div>
                <div class="col-3 pl-1">
                    <button @click.prevent="getResults()" class="mr-2 btn btn-success my-2 my-sm-0 formInput" >Search</button>
                    <button @click.prevent="download()" class="btn btn-success my-2 my-sm-0 formInput" >Download</button>
                </div>
                <div class="col-3 pl-1">
                    <a class="btn btn-info float-right" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                </div>
            </div>
            <div class="details_cont" v-if="this.report_type=='demand'">
                <div v-if="this.data.msg=='notok'">গ্রাহক পাওয়া যায়নি...</div>
                <waterAllDemands v-else :dataList="this.data"></waterAllDemands>
            </div>
            <div class="details_cont" v-else-if="this.report_type=='collections'">
                <div v-if="this.values.msg=='notok'">গ্রাহক পাওয়া যায়নি...</div>
                <waterAllCollections v-else :valueList="this.values"></waterAllCollections>
            </div>
            <div class="details_cont" v-if="this.report_type=='demand-collections'">
                <div v-if="this.data.msg=='notok'">গ্রাহক পাওয়া যায়নি...</div>
                <waterAllDemandCollections v-else :dataList="this.data"></waterAllDemandCollections>
            </div>
        </div>
    </div>
</template>

<script>
import { MonthPickerInput } from 'vue-month-picker'
import Vue from 'vue'
import { mapGetters } from "vuex"
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import waterAllDemands from '@/views/report/components/waterAllDemands'
import waterAllCollections from '@/views/report/components/waterAllCollections'
import waterAllDemandCollections from '@/views/report/components/waterAllDemandCollections'
import axios from "axios";
export default {
    data(){
        return {
            date: {
                from: null,
                to: null,
                month: null,
                year: null,
            },
            report_type:'',
            account_no:'',
            data:{},
            ward:'',
            values:{},
            service_id:'',
            service_list:[],
            invoice_type:'water-billing',
            select_dia:'',
            diameter_list : [],
        }
    },
    methods:{
        async loadContents(page){
            var start = ''
            var end = ''
            var month = ''
            var year =  ''
            if(this.date.from){
                start = this.date.from
                end = this.date.to
                month = this.date.month
                year = this.date.year
            }
            var data = {
                start,month,year,
                end,
                account_no:this.account_no,
                service_id:this.service_id,
                ward:this.ward,
                report_type:this.report_type,
                invoice_type:this.invoice_type
            }
            //console.log(data);
            axios.post('api/water-all-demanad-collections?page='+page,data).then(response=>{
                if(this.report_type=='demand' || this.report_type=='demand-collections'){
                    this.data = response.data
                    this.values = {}
                }else if(this.report_type=='collections'){
                    this.values = response.data
                    this.data = {}
                }
                //console.log(this.data.msg);
            })
        },
        async getResults(page = 1){
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.loadContents(page)
                }
            })
        },
        getSelectService(){
            this.service_list = []
            this.service_id = ''
            axios.get('api/project-all').then(response=>{
                this.diameter_list = response.data
                this.diameter_list.forEach(element=>{
                    if(element.diameter == parseFloat(this.select_dia)){
                        this.service_list.push(element)
                    }
                })

            })
            //this.dia = this.diameter_list


        },
        getFormatedData(val) {
            return val.toFixed(2);
        },
        download(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    let getUserInfo = JSON.parse(localStorage.getItem('user'))
                    let loggedUser = getUserInfo.name
                    var start = ''
                    var end = ''
                    var month = ''
                    var year =  ''
                    if(this.date.from){
                        start = this.date.from
                        end = this.date.to
                        month = this.date.month
                        year = this.date.year
                    }
                    //alert(start);
                    var start_date = new Date(start).toLocaleString('en-US', { timeZone: 'Asia/Dhaka'})
                    var end_date = new Date(end).toLocaleString('en-US', { timeZone: 'Asia/Dhaka'})

                    var download = 'download'

                    window.open(`${axios.defaults.baseURL}/api/water-all-demanad-collections?download=${download}&start=${start_date}&end=${end_date}&bank=${this.bank}&month=${month}&year=${year}&invoice_type=${this.invoice_type}&ward=${this.ward}&service_id=${this.service_id}&account_no=${this.account_no}&report_type=${this.report_type}&loggeduser=${loggedUser}`)
                }
            })
        },
        wardLists(){
            var invoice_type = 'water-billing'
            this.$store.dispatch('WARD_LIST',{invoice_type})
        },

    },
    mounted(){
        this.wardLists();
    },
    computed:{
        ...mapGetters(['wards'])
    },
    components: {
        MonthPickerInput,waterAllDemands,waterAllCollections,waterAllDemandCollections
    },
    props: ['dataList','valueList']
}
</script>
<style scoped>
    .formInput{ height: 41px;}
    .date-time-picker label,.card{font-family: 'Hind Siliguri Light' !important; font-size: 16px;}
    .form-control{ font-size: 16px;}
    .btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}
</style>
